module.exports = __webpack_public_path__ + "static/media/think.f6da03a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/think.png
// module id = 126
// module chunks = 0